import React from 'react'
import Page from 'ui/page'

const MerchantTermsAndConditions = (props) => {
  return (
    <Page {...props}>
      <div>
        <h1 className="text-center">Merchant Terms and Conditions</h1>
      </div>

      <p><strong>Effective Date:</strong> April 15, 2025</p>

      <div>
        <h2>1. Parties Involved</h2>
        <p><strong>Company A (Payment Processor):</strong><br/>
        Anchorage Investments SL<br/>
        Carrer Hort de la Vila 43, Barcelona 08017, Spain<br/>
        CIF: B31900178 <br/>
        Phone: <a href="tel:+17866173997">+1 (786) 617 3997</a><br/>
        Email: <a href="mailto:contact@goforajourney.com">contact@goforajourney.com</a></p>

        <p><strong>Company B (Service Provider):</strong><br/>
        Gofora LLC dba GoforaJourney<br/>
        251 Little Falls Dr, Wilmington, DE 19808, USA</p>
      </div>

      <div>
        <h2>2. Nature of Relationship</h2>
        <p>Company A acts solely as a payment processor and is authorized to collect payments from customers on behalf of Company B for tour operation services. Company A does not organize, manage, or operate any part of the tour and assumes no responsibility for service fulfillment or related disputes.</p>
      </div>

      <div>
        <h2>3. Booking and Payment</h2>
        <p>By placing a booking, you acknowledge that payment is processed by Company A under Spanish law (Ley 16/2009, de servicios de pago) on behalf of Company B. All tour operation services are provided by Company B. Company A provides payment confirmation only. Prices may vary and are confirmed at the time of booking.</p>
      </div>

      <div>
        <h2>4. Cancellations and Refunds</h2>
        <p>Cancellations and refunds are subject to Company B’s policies. Refunds, if approved, will be processed by Company A upon instruction from Company B. Service-related disputes must be addressed to Company B.</p>
      </div>

      <div>
        <h2>5. Liability</h2>
        <p>Company A is not liable for the quality, delivery, or safety of tour services. Company B is responsible for compliance with all applicable U.S. laws, including licensing and insurance.</p>
      </div>

      <div>
        <h2>6. Data and Privacy</h2>
        <p>Your data may be shared between Company A and Company B for booking and service fulfillment, subject to GDPR and applicable U.S. privacy laws.</p>
      </div>

      <div>
        <h2>7. Dispute Resolution</h2>
        <p>Payment issues fall under Spanish jurisdiction and should be addressed to Company A. Service disputes fall under U.S. jurisdiction and must be resolved with Company B.</p>
      </div>

      <div>
        <h2>8. Governing Law</h2>
        <p>Payment-related clauses are governed by the laws of Spain.<br/>
        Service-related clauses are governed by the laws of the United States, specifically the state of Delaware.</p>
      </div>

      <div>
        <h2>9. Contact Information</h2>

        <p>
          <strong>Company A:</strong><br/>
          Email: <a href="mailto:contact@goforajourney.com">contact@goforajourney.com</a><br/>
          Phone: <a href="tel:+17866173997">+1 (786) 617 3997</a>
        </p>

        <p>
          <strong>Company B:</strong><br/>
          Email: <a href="mailto:contact@goforajourney.com">contact@goforajourney.com</a><br/>
          Phone: <a href="tel:+17866173997">+1 (786) 617 3997</a>
        </p>
      </div>
    </Page>
  )
}

export default MerchantTermsAndConditions
